import {useHistory, useLocation} from "react-router";
import {useDispatch} from "react-redux";
import useTheme from "@mui/material/styles/useTheme";
import React, {useEffect, useRef, useState} from "react";
import "./anniv2025.css";
import "../../utils/auth/auth.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField/TextField";
import constants from "../../../config/constants";
import axios from "axios";
import {Login} from "./components/Login";
import {Level1} from "./components/Level1";
import {Level2Taquin} from "./components/Level2Taquin";
import {Level2Einstein} from "./components/Level2Einstein";
import {RankingPage} from "./components/RankingPage";

export const Anniv2025Page = () => {


    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const theme = useTheme();

    const [user, setUser] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [taquin, setTaquin] = useState(false);
    const [einstein, setEinstein] = useState(false);
    const [aNewClue, setANewClue] = useState(0);
    const [ranking, setRanking] = useState(false);

    function emitInput(inputValue) {
        if (inputValue.toLowerCase() === "taquin") {
            setTaquin(true);
        }
        if (inputValue.toLowerCase() === "einstein") {
            setEinstein(true);
        }
        if(inputValue.toLowerCase() === "classement"){
            setRanking(true);
        }
    }

    function setTaquinComplete() {
        user.taquin = true;
        axios.post(constants.api.basePath + "/anniv2025/taquin/completed", {username: user.username, password}).then(res => {
        }).catch(err => {
        });
    }

    function setEinsteinComplete() {
        user.einstein = true;
        axios.post(constants.api.basePath + "/anniv2025/einstein/completed", {username: user.username, password}).then(res => {
        }).catch(err => {
        });
    }

    return (
        <Box className="board-game" sx={{width: {xs: "80%", md: "50%"}}}>
            <div style={{marginBottom: "3vh", textAlign: 'center'}}>
                <h2>
                    Anniv 2025
                </h2>
            </div>
            {
                user ?
                    <div>
                        {
                            taquin ?
                                <Level2Taquin
                                    isCompleted={user.taquin}
                                    setBack={() => setTaquin(false)}
                                    setCompleted={setTaquinComplete}></Level2Taquin> :
                                undefined
                        }
                        {
                            einstein ?
                                <Level2Einstein
                                    isCompleted={user.einstein}
                                    setBack={() => setEinstein(false)}
                                    setCompleted={setEinsteinComplete}></Level2Einstein> :
                                undefined
                        }
                        {
                            ranking ?
                                <RankingPage
                                    setRankingDisplay={setRanking}>

                                </RankingPage>:
                                undefined
                        }
                        {
                            aNewClue ?
                                <div className="new-clue">
                                    <img src={"/public/anniv/2025/un_nouvel_indice_" + aNewClue + ".png"}/>
                                    <br/>
                                    <div>
                                        <Button variant="contained" disabled={aNewClue <= 1} onClick={() => setANewClue(aNewClue - 1)}>{"<"}</Button>
                                           
                                        <Button variant="contained" disabled={aNewClue >= 13} onClick={() => setANewClue(aNewClue + 1)}>></Button>
                                    </div>
                                    <br/>
                                    <Button variant="contained" onClick={() => setANewClue(0)}>Retour</Button>
                                </div> :
                                undefined
                        }
                        {
                            !taquin && !aNewClue && !ranking && !einstein ?
                            <div>
                            <Level1
                            user={user}
                            password={password}
                        setUser={setUser}
                        emitInput={emitInput}
                        setANewClue={setANewClue}
                    ></Level1>
                </div> :
                undefined
            }
                </div> :
                <Login setUser={setUser} setPasswordOutput={setPassword}/>
}
</Box>
)
    ;
}
